<div #uplotContainer class="uplot-container">
  <div class="uplot-header">
    @if (loaded) {
      <ng-content></ng-content>
      <ng-container>
        @if (showSettings && getButtonsOpts() && uplot) {
          <div>
            <app-graph-buttons [opts]="getButtonsOpts()" [rangeInHours]="rangeInHours">
              <!--    <span>{{ getRangeString(currentRange) }}</span>-->
            </app-graph-buttons>
          </div>
        }
        <div class="ranges">
          @if (showScaleSettings) {
            <app-scale-settings
              [currentScale$]="currentScale$"
              [rangeInHours]="rangeInHours"
            ></app-scale-settings>
          }

          <app-uplot-range-picker
            [currentRange]="currentRange"
            (rangeHasChanged)="setUplotRange($event)"
          ></app-uplot-range-picker>
        </div>
      </ng-container>
    }
  </div>
</div>
